import gql from 'graphql-tag';

// Generic Session info gql.
const sessionInfo = `
	Session {
		sessionId
		LoggedIn
		User {
			userId
			companyId
			firstName
			lastName
			userTypeId
			Permissions {
				userPermissionId
				permissionLevel
				permissionLevelString
				Permission {
					permissionId
					permission
				}
			}
		}
	}
`;
// ${sessionInfo}
export const LoginMutation = gql`
      mutation login($input: LoginInput) {
		login (input: $input) {
            user_ID
            archiver_ID
            arm_length_left
            arm_length_right
            athletic
            creator_ID
            customer_ID
            customer_name
            date_archived
            date_birth
            date_created
            date_updated
            email
            first_name
            forearm_length_left
            forearm_length_right
            gender
            height_feet
            height_inches
            last_name
            level
            medical
            password
            phone_number
            player_number
            player_position
            rookie_season
            school_year
            sport
            updater_ID
            user_name
            user_type_ID
            weight
	}
}`;
